import React from "react";
import {
  CalendlyLogo,
  GoogleCalendarLogo,
  AppleCalendarLogo,
  MicrosoftLogo,
  SalesforceLogo,
  HubSpotLogo,
  PipedriveLogo,
  ZohoLogo,
  GoHighLevelLogo,
  FreshworksLogo,
  ZendeskLogo,
  IntercomLogo,
} from "./icons";

// `apiKey` is the field name the assistant record uses inside its
// `integrations` map. A key the API does not return at all is one the backend
// has not built yet, so the tile shows "Coming soon" instead of a Connect
// button that could not do anything.

// Drives the filter toggle, in the order it renders.
export const categories = ["All", "CRM", "Scheduling", "Helpdesk"];

export const integrations = [
  
  // ---- Scheduling --------------------------------------------------------
  {
    id: "calendly",
    name: "Calendly",
    apiKey: "calendly",
    category: "Scheduling",
    logo: <CalendlyLogo />,
    description:
      "Let the assistant book meetings straight onto your Calendly availability.",
    connected: false,
  },
  {
    id: "google-calendar",
    name: "Google Calendar",
    apiKey: "googleCalendar",
    category: "Scheduling",
    logo: <GoogleCalendarLogo />,
    description:
      "Check real-time availability and drop confirmed bookings into Google Calendar.",
    connected: false,
  },
  {
    id: "microsoft-calendar",
    name: "Microsoft Outlook",
    apiKey: "microsoftCalendar",
    category: "Scheduling",
    logo: <MicrosoftLogo />,
    description:
      "Book into Outlook and Microsoft 365 calendars without leaving the chat.",
    connected: false,
  },
  {
    id: "apple-calendar",
    name: "Apple Calendar",
    apiKey: "appleCalendar",
    category: "Scheduling",
    logo: <AppleCalendarLogo />,
    description:
      "Sync bookings to Apple Calendar so they show up across Mac, iPhone and iPad.",
    connected: false,
  },

  // ---- CRM ---------------------------------------------------------------
  {
    id: "hubspot",
    name: "HubSpot",
    apiKey: "hubspot",
    category: "CRM",
    logo: <HubSpotLogo />,
    description:
      "Sync leads and conversation history into HubSpot contacts and deals.",
    connected: false,
  },
  {
    id: "pipedrive",
    name: "Pipedrive",
    apiKey: "pipedrive",
    category: "CRM",
    logo: <PipedriveLogo />,
    description:
      "Create a Pipedrive deal the moment your assistant qualifies a lead.",
    connected: false,
  },
  {
    id: "salesforce",
    name: "Salesforce",
    apiKey: "salesforce",
    category: "CRM",
    logo: <SalesforceLogo />,
    description:
      "Push every captured lead into Salesforce as a new contact or opportunity.",
    connected: false,
  },
  {
    id: "zoho",
    name: "Zoho CRM",
    apiKey: "zoho",
    category: "CRM",
    logo: <ZohoLogo />,
    description:
      "Send new leads and their full chat transcript straight to Zoho CRM.",
    connected: false,
  },
  {
    id: "gohighlevel",
    name: "GoHighLevel",
    apiKey: "goHighLevel",
    category: "CRM",
    logo: <GoHighLevelLogo />,
    description:
      "Drop captured contacts into your GoHighLevel pipelines and workflows.",
    connected: false,
  },

  // ---- Helpdesk ----------------------------------------------------------
  {
    id: "zendesk",
    name: "Zendesk",
    apiKey: "zendesk",
    category: "Helpdesk",
    logo: <ZendeskLogo />,
    description:
      "Raise a Zendesk ticket automatically when the assistant escalates to your team.",
    connected: false,
  },
  {
    id: "freshdesk",
    name: "Freshdesk",
    apiKey: "freshdesk",
    category: "Helpdesk",
    logo: <FreshworksLogo />,
    description:
      "Hand off unresolved chats to Freshdesk with the full transcript attached.",
    connected: false,
  },
  {
    id: "intercom",
    name: "Intercom",
    apiKey: "intercom",
    category: "Helpdesk",
    logo: <IntercomLogo />,
    description:
      "Pass conversations to an Intercom inbox so a human can pick up where the bot left off.",
    connected: false,
  },
];
